import PropTypes from 'prop-types';
import React, { useContext } from 'react';

import AcceptChat from 'components/customer/composition/accept_chat_window';
import ChatActions from './chat/chat_actions';
import ChatComposerButtons from './chat/composer_buttons';
import Composer, { Header, HeaderText, useComposer } from './shared/composer';
import ComposerContext from 'components/composer/contexts/composer_context';
import connect from 'components/lib/connect';
import { EditorContainer, useEditor } from './shared/editor';
import { isEditorEmpty } from 'components/text_editor/helpers';
import { mapStateToProps } from './chat_composer_shared';
import MessagingEditor from './editors/messaging';
import PlaintextSerializer from 'components/text_editor/serializers/plaintext_serializer';
import SendChat from 'actions/composer/send_chat';
import { useChatOnChange } from './chat/chat_hooks';

export function ChatComposerBase({ disableSubmit, shouldShowAcceptChat }) {
  const { composition } = useContext(ComposerContext);
  const composer = useComposer(SendChat);
  const onChange = useChatOnChange();
  const editorProps = useEditor('bodyHtml', composer, { attr: 'text', serializer: PlaintextSerializer, onChange });
  const [composerProps] = composer;

  let content = <AcceptChat />;
  let submitButton = null;

  if (!shouldShowAcceptChat) {
    content = (
      <EditorContainer includeAttachments>
        <MessagingEditor placeholder="Type to chat" {...editorProps} />
      </EditorContainer>
    );

    const { onSubmit } = composerProps;
    submitButton = (
      <ChatActions
        isEditorEmpty={isEditorEmpty(editorProps.value) && !composition.hasAttachments()}
        onSubmit={onSubmit}
      />
    );
  }

  return (
    <Composer
      disableSubmit={disableSubmit}
      includeAttachments
      submitButton={submitButton}
      submitText="Send"
      {...composerProps}
    >
      <Header>
        <HeaderText color="green400">Chat</HeaderText>
        <ChatComposerButtons {...editorProps} />
      </Header>
      {content}
    </Composer>
  );
}

ChatComposerBase.propTypes = {
  attachmentsEnabled: PropTypes.bool,
  disableSubmit: PropTypes.bool,
  shouldShowAcceptChat: PropTypes.bool,
};

export const ChatComposer = connect(mapStateToProps)(ChatComposerBase);

export default React.memo(ChatComposer);
